import React, { FC } from "react"
import { Text } from "dash-styled"
import { QualifierCardMetricModel } from "../../../../../../../../Models/API/QualifierModel"
export interface QualifierCardMetricProps {
    data: QualifierCardMetricModel
}

export const QualifierCardMetric: FC<QualifierCardMetricProps> = ({ data }) => (
    <div className="flex flex-1 flex-col items-center w-32">
        <Text className="mt-0 mb-1 text-4xl text-smoke-610 leading-9" size="lg">
            {data.value}
        </Text>
        <Text className="m-0 text-rhino-700 text-center" size="sm">
            {data.description}
        </Text>
    </div>
)
